import { StickyButtonPreview } from '..';

function ChatbotWidget() {
  return <StickyButtonPreview />;
}

export default ChatbotWidget;
